import styled from 'styled-components';

function getBackgroundColor(props) {
  switch (props.backgroundType) {
    case 'primary':
      return `
        background: ${props.theme.primary};
        transition:0.2s;
        &:hover,
        &:active {
          opacity: 0.5 ;
          color: #fff;
        }
      `;
    case 'action':
      if(props.theme.action == '#EEE3FF'){
        return `
          background: ${props.theme.action};
          transition:0.2s;
          color:${props.theme.primary};
          &:hover,
          &:active {
            opacity: 0.5 ;
          }
        `;
      }
      else{
        return `
          background: ${props.theme.action};
          transition:0.2s;
          color:'white';
          &:hover,
          &:active {
            opacity: 0.5 ;
          }
        `;
      }
    case 'secondary':
      return `
        background: ${props.theme.buttonSecondary};
      `;
    default:
      return `
        background: ${props.theme.button};
      `;
  }
}

// eslint-disable-next-line import/prefer-default-export
export const AddReferencia = styled.button`
  color: #fff;
  font-size: 12px;
  border: none;
  ${props => getBackgroundColor(props)};
`;
